import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from 'AppRoutes';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from 'theme';
import { ThemeProvider } from '@material-ui/core/styles';
import { AuthProvider } from 'components/AuthProvider';
import { ReactQueryDevtools } from 'react-query-devtools';
import { SubClientProvider } from 'graphql/client';
import { SnackbarKey, SnackbarProvider, useSnackbar } from 'notistack';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const SnackbarAction = (key: SnackbarKey) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton size="small" onClick={() => closeSnackbar(key)} color="inherit">
      <CloseIcon />
    </IconButton>
  );
};

function App() {
  return (
    <>
      <ReactQueryDevtools />
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <SnackbarProvider
            autoHideDuration={10000}
            action={SnackbarAction}
            anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          >
            <AuthProvider>
              <SubClientProvider>
                <AppRoutes />
              </SubClientProvider>
            </AuthProvider>
          </SnackbarProvider>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

export default App;
